import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { profileApi, type Favorite } from '@/services/api';
import { formatFieldValue } from '@/components/feature/GreenCertFieldConfig';

export default function MyFavoritesPage() {
  const [items, setItems] = useState<Favorite[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    profileApi
      .favorites()
      .then((data) => {
        setItems(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const removeFavorite = async (id: number) => {
    try {
      await profileApi.removeFavorite(id);
      setItems((prev) => prev.filter((f) => f.id !== id));
    } catch {
      // silently fail
    }
  };

  return (
    <>
      <Navbar />
      <main className="w-full bg-background-50 min-h-screen">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-12">
          <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-8">我的收藏</h1>
          {loading ? (
            <div className="text-center py-12">
              <div className="w-8 h-8 mx-auto rounded-full border-2 border-primary-500 border-t-transparent animate-spin"></div>
            </div>
          ) : items.length === 0 ? (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto rounded-full bg-background-100 flex items-center justify-center">
                <i className="ri-bookmark-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500 mt-4 text-sm">暂无收藏</p>
              <Link
                to="/supply"
                className="inline-block mt-3 text-primary-600 text-sm hover:underline cursor-pointer"
              >
                去浏览供给列表
              </Link>
            </div>
          ) : (
            <div className="space-y-4">
              {items.map((item) => {
                const projectLabel = formatFieldValue('projectType', item.projectType);
                return (
                  <div
                    key={item.id}
                    className="bg-background-50 rounded-xl border border-background-200 p-5 hover:border-primary-200 transition-colors"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center gap-2">
                        <span className={`px-2 py-0.5 text-xs font-medium rounded ${
                          item.type === 'supply' ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-700'
                        }`}>
                          {item.type === 'supply' ? '供给' : '需求'}
                        </span>
                        <h3 className="font-heading text-base font-semibold text-foreground-900">
                          {item.company}
                        </h3>
                      </div>
                      <button
                        onClick={() => removeFavorite(item.id)}
                        className="w-8 h-8 flex items-center justify-center text-accent-500 cursor-pointer hover:scale-110 transition-transform"
                      >
                        <i className="ri-heart-fill" />
                      </button>
                    </div>
                    <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-foreground-500">
                      <span>{projectLabel}</span>
                      <span>{item.year}年度</span>
                      <span>{item.quantity.toLocaleString()} 个</span>
                      <span>{item.region}</span>
                      <span>&yen;{item.price}/个</span>
                    </div>
                    <div className="mt-3">
                      <Link
                        to={`/${item.type === 'supply' ? 'supply' : 'demand'}/${item.itemId}`}
                        className="text-primary-600 text-sm hover:underline cursor-pointer"
                      >
                        查看详情 →
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}